import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { services } from '../mockData';

const ServicesPage = () => {
    return (
        <div className="min-h-screen">
            <SEO
                title="Hizmetlerimiz | Ankara Merkez Far"
                description="Ankara Merkez Far olarak sunduğumuz hizmetler: Far camı değişimi, far mercek değişimi, gösterge camı tamiri, stop lambası tamiri ve tüm far bakım hizmetleri."
                keywords="far tamircisi ankara, far hizmetleri, far camı değişimi, far mercek değişimi, stop tamiri, gösterge camı tamiri"
                url="https://ankaramerkezfar.com/hizmetler"
            />
            <Header />

            {/* Page Header */}
            <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16 md:py-20">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Hizmetlerimiz</h1>
                    <p className="text-lg text-gray-300 max-w-2xl">
                        Far ve stop tamir hizmetlerimizle aracınızı yeni gibi yapmanıza yardımcı oluyoruz.
                    </p>
                </div>
            </section>

            {/* Services Grid */}
            <section className="py-16 md:py-24 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {services.map((service) => (
                            <Link
                                key={service.id}
                                to={service.link}
                                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                            >
                                <div className="relative h-64 overflow-hidden">
                                    <img
                                        src={`${service.image}?w=600&h=400&fit=crop`}
                                        alt={service.title}
                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                                    <div className="absolute bottom-4 left-4 right-4">
                                        <h3 className="text-xl font-bold text-white mb-1">{service.title}</h3>
                                    </div>
                                </div>
                                <div className="p-6">
                                    <p className="text-gray-600 mb-4">{service.description}</p>
                                    <div className="flex items-center text-blue-600 font-semibold group-hover:gap-2 transition-all">
                                        <span>Detaylı Bilgi</span>
                                        <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ServicesPage;
